import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { addressFieldDescriptors } from './_addressFields.js';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { DISTRIBUTION_CENTER } from '../types/distribution-center.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for DistributionCenter entity.
 * Stored in 'org/{orgId}/distribution-center'.
 *
 * Default data source is PostgresRest — ledger FKs (fase D) require the catalog
 * in the same database (ADR 0003 §D7; request 0094).
 */
export const distributionCenterDescriptor = {
    name: DISTRIBUTION_CENTER,
    label: 'Centro de Distribuição',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/distribution-center',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Physical distribution center / warehouse site',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique distribution center identifier',
        },
        {
            name: 'code',
            example: 1,
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric CD code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'name',
            example: 'CD Gaspar',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Distribution center name',
        },
        // Standard address block, reference mode (spec 0047 §4.1 / D22) — the same
        // nine fields as Party. It replaced `addressLine`/`city`/`state`, which are
        // three renames and therefore three orphan columns in Postgres until the
        // manual `DROP COLUMN` (request 0251 §3): `pgSchema.service.ts` only adds.
        ...addressFieldDescriptors(),
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    // No address FK (D31): `addressCityId`/`addressStateId` hold IBGE codes, not references.
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=distribution-center.descriptor.js.map